import { useState } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    question: '哔咔漫画是免费的吗？',
    answer: '哔咔漫画提供大量免费漫画资源，部分漫画可能需要VIP订阅或使用阅读券。平台会定期推出限时免费活动，新用户注册后通常可以获得一定数量的免费阅读券，让你充分体验平台内容。',
  },
  {
    question: '哔咔漫画支持哪些设备？',
    answer: '哔咔漫画目前支持安卓手机/平板（Android 7.0及以上）和苹果iPhone/iPad（iOS 13.0及以上）。安卓版可直接从官网下载APK安装，iOS版通过TestFlight获取。两个平台的阅读体验都已深度优化。',
  },
  {
    question: '哔咔漫画的漫画资源是正版的吗？',
    answer: '是的，哔咔漫画平台上的所有漫画资源均为正版授权。平台与国内外多家漫画出版社和内容提供商建立了合作关系，确保所有内容的合法性和质量。支持正版漫画有助于漫画产业的健康发展。',
  },
  {
    question: '如何找回哔咔漫画的登录密码？',
    answer: '在登录页面点击"忘记密码"，输入绑定的手机号或邮箱，系统会发送验证码。验证通过后即可设置新密码。如果无法通过以上方式找回，请联系官方客服获取帮助。建议平时绑定手机号和邮箱双重保障。',
  },
  {
    question: '哔咔漫画的离线下载会占用很多空间吗？',
    answer: '离线下载的存储空间取决于你选择的画质。标清模式每话约2-5MB，高清模式每话约5-15MB。你可以在设置中选择默认下载画质，也可以在下载时单独选择。建议定期清理已读完的缓存，在"我的-下载管理"中操作。',
  },
  {
    question: '哔咔漫画在国内可以正常使用吗？',
    answer: '哔咔漫画在国内可以正常使用。平台服务器部署在国内，加载速度快，漫画图片加载稳定。如果遇到网络问题，建议检查网络连接或切换Wi-Fi/移动数据试试。',
  },
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            常见问题解答
          </h2>
          <p className="text-sm text-foreground-500">
            关于哔咔漫画的常见疑问，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <span className={`w-5 h-5 flex items-center justify-center transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-lg text-foreground-400"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-4 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/changjian-wenti"
            className="inline-flex items-center space-x-2 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            <span>查看更多常见问题</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;